import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import LiveSearch from "@/components/LiveSearch";

export default function SearchPage() {
    const [params, setParams] = useSearchParams();
    const { t } = useLang();
    useEffect(() => { document.title = `${t("search")} | ${t("siteName")}`; }, [t]);
    return (
        <div className="mx-auto max-w-3xl px-4 py-6 md:py-8">
            <h1 className="font-display font-black text-2xl md:text-3xl text-brand-black mb-4" data-testid="search-title">{t("searchTitle")}</h1>
            <LiveSearch initialQ={params.get("q") || ""} autoFocus testId="search-page"
                onQueryChange={(q) => setParams(q ? { q } : {}, { replace: true })} />
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-3" data-testid="search-hint">{t("searchHint")}</p>
        </div>
    );
}
